// This is where Jared & Jeff will put their custom JS for the new theme

// for the bundle and save section on the home page --------
// takes the two displayed products, grabs their price in the hidden HTML, does some math and shows the final bundle price underneath
const finalPromoPrice = document.getElementById('promoPrice');
if (finalPromoPrice != null) {
    const firstPromoPrice = document.getElementsByClassName('promoBundle-left')[0].getElementsByClassName('price-item--regular')[0].innerHTML,
        secondPromoPrice = document.getElementsByClassName('promoBundle-right')[0].getElementsByClassName('price-item--regular')[0].innerHTML,
        discountedPromoPrice = document.getElementById('promoPriceDiscounted'),
        discountPercent = 1.2;

    // do the math
    let jared = parseFloat(firstPromoPrice.replace('$', '')) + parseFloat(secondPromoPrice.replace('$', ''));
    let jeff = jared / discountPercent;

    finalPromoPrice.innerHTML = '$' + jared.toFixed(2);
    discountedPromoPrice.innerHTML = '$' + jeff.toFixed(2);
}


// This is for the out of stock modal - so customers can get notified when a product is back in stock
const modal = document.getElementById('modal-container');
const modalContent = modal.getElementsByClassName('modal-content')[0];
const modalClose = modal.getElementsByClassName('icon-close')[0];

// handle closing the modal with the X button
modalClose.addEventListener("pointerdown", () => {
    modal.classList.toggle("hideMenu");
})

// when you click the 'Notify' button, add the product details to the modal & unhide it
function notifyBtns() {
    const notifyBtns = document.querySelectorAll('.product-notify.card');
    notifyBtns.forEach((item) => {
        item.addEventListener("pointerdown", (event) => {
            // get the product url from the title, and append ?notify to it
            const card = item.closest('.productCard');
            let pathname = card.querySelector('.card__heading a').getAttribute('href');
            pathname = pathname.split('?')[0];
            pathname = pathname + '?notify';
            window.location.assign(window.location.protocol + '//' + window.location.hostname + pathname);
        })
    })
}
// also called on filtering.js file
notifyBtns();

function cart(event) {
    document.getElementById('promo-loading').classList.remove('hidden')
    event.target.classList.add('hidden');
    let amount = document.getElementById('donate_quantity').value;
    // gets the (variant_id) hidden input value
    let id = event.target.previousElementSibling.value;
    add_to_cart(id, amount);
}

function add_to_cart(id, amount) {
    let data = {
        'items': [{
            'id': id,
            'quantity': amount
        }]
    }
    let route = window.Shopify.routes.root + 'cart/add.js';
    let options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    }
    fetch(route, options)
        .then(response => response.json())
        .then(data => console.log(data))
        .catch(error => console.error('Error:', error))
        .finally(() => { window.location = "/cart" })
}

function cart_promo_close(event) {
    const container = event.target.closest('.ss-promo-container');
    container.classList.add('hideMenu');
}

// ---------- custom select element code (from W3 Schools XD) ----------
var x, i, j, l, ll, selElmnt, a, b, c, d, e, id;
/* 
x = custom select (container)
l = how many custom selects
setElmnt = the actual select element in X (custom select)
a = new selected item DIV element
b = option list container DIV
c = individual option DIV
j = index for loop of select options
i = index for choosing selected option in event listener
*/

x = document.getElementsByClassName("custom-select");
l = x.length;
id = document.querySelector('input[name="product-id"]')
// console.log('ids: ', product_ids);
// console.log('product images: ', product_images);

for (i = 0; i < l; i++) {
    selElmnt = x[i].getElementsByTagName("select")[0];
    ll = selElmnt.length;
    // for each element, create a new DIV that will act as the selected item:
    a = document.createElement("DIV");
    a.setAttribute("class", "select-selected");
    a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
    x[i].appendChild(a);
    // for each element, create a new DIV that will contain the option list:
    b = document.createElement("DIV");
    b.setAttribute("class", "select-items select-hide");
    for (j = 1; j < ll; j++) {
        // for each option in the original select element, create a new DIV that will act as an option item
        c = document.createElement("DIV");
        c.setAttribute("data-index", j - 1);
        // add product image
        d = document.createElement('img');
        d.src = product_images[j - 1];
        // add product text from the original select item
        e = document.createElement('span')
        e.innerHTML = selElmnt.options[j].innerHTML;
        c.append(d, e);
        c.addEventListener("click", function (e) {
            // when an item is clicked, update the original select box, and the selected item:
            var y, i, k, select, h, sl, yl;
            // set the hidden product id input
            let index = this.getAttribute("data-index");
            id.value = product_ids[index];
            select = this.parentNode.parentNode.getElementsByTagName("select")[0];
            sl = select.length;
            h = this.parentNode.previousSibling;
            for (i = 0; i < sl; i++) {
                // when we find the matching select item that the user clicked
                if (select.options[i].innerHTML == this.children[1].innerHTML) {
                    select.selectedIndex = i;
                    // update the selected item
                    let html = this.children[1].innerHTML.trim();
                    h.innerHTML = html.substring(0, 30) + '...';
                    y = this.parentNode.getElementsByClassName("same-as-selected");
                    yl = y.length;
                    // remove all instances of "same-as-selected" class
                    for (k = 0; k < yl; k++) {
                        y[k].removeAttribute("class");
                    }
                    this.setAttribute("class", "same-as-selected");
                    break;
                }
            }
            h.click();
        });
        b.appendChild(c);
    }
    // append the "see all products" link at the end
    c = document.createElement("DIV");
    d = document.createElement('a');
    d.setAttribute("href", "/collections/nutrisource-cart-promo-products");
    d.innerHTML = "SEE ALL PRODUCTS";
    c.append(d);
    b.appendChild(c);
    // stuff and nonsense
    x[i].appendChild(b);
    a.addEventListener("click", function (e) {
        // when the select box is clicked, close any other select boxes and open/close the current select box:
        e.stopPropagation();
        closeAllSelect(this);
        this.nextSibling.classList.toggle("select-hide");
        this.classList.toggle("select-arrow-active");
    });
}


function closeAllSelect(elmnt) {
    // close all select boxes in the document, except the current select box
    var x, y, i, xl, yl, arrNo = [];
    x = document.getElementsByClassName("select-items");
    y = document.getElementsByClassName("select-selected");
    xl = x.length;
    yl = y.length;
    for (i = 0; i < yl; i++) {
        if (elmnt == y[i]) {
            arrNo.push(i)
        } else {
            y[i].classList.remove("select-arrow-active");
        }
    }
    for (i = 0; i < xl; i++) {
        if (arrNo.indexOf(i)) {
            x[i].classList.add("select-hide");
        }
    }
}
// if the user clicks anywhere outside the select box, close all select boxes
document.addEventListener("click", closeAllSelect);


/* for the BOLD items reordering
- create two array: Months and Weeks
- loop through bold plan options, if innerHTML.contains('week') go to week and vice versa
- then check by number
- see what order they get added to a master array
- replace the innerHTML on the page
*/

if (window.location.href.includes('notify')) {
    setTimeout(() => { document.getElementById('notify').click() }, 500)
}

